export default __webpack_public_path__ + "static/media/Kodchasan-Bold.bb390fdb.ttf";